import React from 'react';
import PropTypes from 'prop-types';

import connect from 'app/libs/connect';
import Text from 'app/components/layout/Text.styled';
import { isUserAuthenticated } from 'app/features/user/selectors';
import ContinueExploring from 'app/features/landing/productComparison/components/AlternativeLink/ContinueExploring';
import CreateFreeAccount from 'app/features/landing/productComparison/components/AlternativeLink/CreateFreeAccount';

const UI = ({ isAuthenticated }) => (
  <Text data-t="alternative-link" size="xl">
    {isAuthenticated ? <ContinueExploring /> : <CreateFreeAccount />}
  </Text>
);

UI.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
};

const AlternativeLink = connect({ isAuthenticated: isUserAuthenticated })(UI);

export { UI };

export default AlternativeLink;
